import { Category } from './../../generics/data-printer/data-printer.component';
import { NotificationsService } from './../../../services/notifications.service';
import { Component, OnInit } from '@angular/core';
import { ErrorResponse } from '../../../models/error.model';
import { ActivatedRoute } from '@angular/router';
import { ReportsService } from '../../../services/reports.service';
import { UtilsService } from '../../../services/utils.service';

@Component({
    selector: 'app-notification-details',
    templateUrl: './notification-details.component.html',
    styleUrls: ['./notification-details.component.scss']
})
export class NotificationDetailsComponent implements OnInit {

    categories: Category[] = [];
    returnUrl: string;

    constructor(
        private utilsService: UtilsService,
        private notificationsService: NotificationsService,
        private route: ActivatedRoute
    ) { }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            if (params.id) {
                this.notificationsService.getNotificationById(params.id).subscribe(notification => {
                    this.categories = [
                        { name: 'Información general', items: [
                            { label: 'Fecha', value: notification.fechaCreacion, type: 'datetime' },
                            { label: 'Fecha lectura', value: notification.fechaLectura ? this.utilsService.beautifyDate(notification.fechaLectura, 'L HH:mm') : 'No leida' },
                            { label: 'Título', value: notification.titulo },
                            { label: 'Contenido', value: notification.contenido },
                        ]},
                    ];
                }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener reporte', error.error?.descripcion));

            }
        });
        this.route.queryParams.subscribe(params => {
            if (params.returnUrl) {
                this.returnUrl = params.returnUrl;
            }
        });
    }
}
